module.exports = __webpack_public_path__ + "static/media/other_digital_not_active.fc6b0342.svg";